export const STORE_PARTNER = 'store/partner'
